import { useState, useEffect } from 'react';
import { useParams } from 'react-router';

const useOpenbox = () => {
    const { id } = useParams();
    const elementosPorPagina = 0;

    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [load, setLoad] = useState(true);
    const [cantidadDePaginas, setCantidadDePaginas] = useState(0);

    const obtenerDatos = () => {
        setData([]);
        setCantidadDePaginas(0);
        setLoad(true);
    };


    useEffect(() => {
        if (id !== undefined) {
            setCurrentPage(1);
        }
        obtenerDatos();
    }, [id]);

    const handleNextPage = () => {
        return;
    };


    return { data, load, currentPage, cantidadDePaginas, handleNextPage, elementosPorPagina };
}

export default useOpenbox;
